import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=a2898904&scoped=true&"
import script from "./assign.vue?vue&type=script&lang=ts&"
export * from "./assign.vue?vue&type=script&lang=ts&"
import style0 from "./assign.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./assign.vue?vue&type=style&index=1&id=a2898904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2898904",
  null
  
)

export default component.exports